module.exports = __webpack_public_path__ + "static/media/homepage-follow.e6566ea3.png";